import { render, staticRenderFns } from "./CommunicationsTable.vue?vue&type=template&id=10ca9c72&scoped=true"
import script from "./CommunicationsTable.vue?vue&type=script&lang=js"
export * from "./CommunicationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca9c72",
  null
  
)

export default component.exports